<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import ModalWrapper from '@/components/modals/Modal-wrapper.vue';

const b = bem('email-frame-selector');

export default {
  components: {
    ModalWrapper,
  },
  data() {
    return {
      selectedCollection: null,
      selectedFrame: null,
      selectedOption: null,
      visible: true,
    };
  },
  props: {
    close: {
      type: Function,
      required: false,
      default: () => {},
    },
    save: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  methods: {
    ...mapActions({
      getCollectionDetailsAction: 'collections/getCollectionDetails',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    onClickCollection(value) {
      const item = (this.collections || []).find(({ id }) => value === id) || {};
      const { id } = item || {};
      if (!this.selectedCollection || id !== this.selectedCollection.value) {
        this.getCollectionDetailsAction({ id });
        this.selectedCollection = value;
        this.selectedFrame = null;
        this.selectedOption = null;
      }
    },
    onClickFrame(value) {
      const item = this.getFrameList().find(({ value: id }) => id === value);
      const { value: id } = item || {};

      if (!this.selectedFrame || id !== this.selectedFrame.value) {
        this.selectedFrame = item;
        this.selectedOption = null;
      }
    },
    onClickOption(value) {
      this.selectedOption = value;
    },
    getFrameList() {
      if (!this.collection) {
        return [];
      }

      const {
        products = [],
      } = this.collection || {};

      return (products || [])
        .map(({ displayName, id }) => ({ label: displayName, text: displayName, value: id }));
    },
    getOptions() {
      if (!this.collection || !this.selectedFrame) {
        return [];
      }
      const {
        products = [],
      } = this.collection || {};
      const frame = products.find((item) => (item.id === this.selectedFrame.value)) || {};
      const { options = [] } = frame || {};
      const list = (options || []).map((item) => {
        const {
          displayName = '',
          frameSize: { name: sizeName = '' },
          frameColor: { name: colorName = '' },
          frameOrientation = '',
          id = 0,
        } = item || {};

        return {
          value: id,
          label: `${displayName} ${sizeName} ${colorName} ${frameOrientation}`,
          text: `${displayName} ${sizeName} ${colorName} ${frameOrientation}`,
        };
      });
      return list;
    },
  },
  computed: {
    ...mapState({
      collections: (state) => (state.collections || {}).collections || [],
      collection: (state) => state.collections.collection,
      isLoadingCollection: (state) => state.collections.isLoadingCollection,
    }),
  },
  watch: {
    visible(newValue) {
      if (!newValue) {
        this.close();
      }
    },
  },
};

</script>

<template>
  <modal-wrapper v-model:show="visible">
    <div :class="b()">
      <div :class="b('selector-wrap')">
        <div :class="b('selector-name')">Collections</div>
        <a-select
          style="width: 180px"
          :value="selectedCollection"
          :options="
            (collections || []).map(({ name, id }) => ({ label: name, text: name, value: id }))
          "
          @change="onClickCollection"
        />
      </div>
      <div :class="b('selector-wrap')">
        <div :class="b('selector-name')">Frame</div>
        <div
          :class="b('selector-info')"
          v-if="isLoadingCollection"
        >
          Loading ...
        </div>
        <div
          :class="b('selector-info')"
          v-if="!selectedCollection"
        >
          Please select collection
        </div>
        <a-select
          v-if="!isLoadingCollection && selectedCollection"
          style="width: 180px"
          :value="selectedFrame"
          :options="getFrameList()"
          @change="onClickFrame"
        />
      </div>
      <div :class="b('selector-wrap')">
        <div :class="b('selector-name')">Options</div>
        <div
          :class="b('selector-info')"
          v-if="!selectedFrame"
        >
          Please select frame
        </div>
        <a-select
          v-if="selectedFrame"
          style="width: 180px"
          :value="selectedOption"
          :options="selectedFrame ? getOptions() : []"
          @change="(e) => { onClickOption(getOptions().find(({value}) => value === e)) }"
        />
      </div>
      <div :class="b('modal-buttons-wrap')" >
        <a-button
          type="primary"
          html-type="button"
          :disabled="!selectedOption"
          @click="() => {save(selectedOption)}"
        >
          Save
        </a-button>
        <a-button
          html-type="button"
          @click="cancel()"
        >
          Cancel
        </a-button>
      </div>
    </div>
  </modal-wrapper>
</template>;

<style src="./emailFrameSelectorStyle.scss" scoped lang="scss"></style>
